import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { describeError } from './lib/sl.ts';
import { showToast } from './lib/toast.ts';
import { App } from './App.tsx';
import './styles.css';

const queryClient = new QueryClient({
  // The cache reports a failure only once its retries are exhausted, so
  // anything arriving here has genuinely given up and is worth saying out
  // loud. Doing it in one place means every query is covered -- departures,
  // the picker, the stop list -- without each screen inventing its own
  // error banner.
  queryCache: new QueryCache({
    onError: (error) => showToast(describeError(error)),
  }),
  defaultOptions: {
    queries: {
      // Per-query settings do the real work here (see lib/queries.ts): the
      // board wants no staleness at all, the stop list never goes stale.
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
